<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="800px">
    <v-card>
        <v-row class="my-0 py-0" dense>
          <v-col class="text-right">
            <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-card-title>
          <v-row class="my-0 py-0">
            <v-col>
              {{ notesTrack.name }}
            </v-col>
          </v-row>
        </v-card-title>
      <v-card-text>
        <v-textarea v-model="notesTrack.notes" label="Notes" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="updateTrack" color="success"
          >save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import danger from '@/helpers/danger'
import blanks from '@/helpers/blanks'
import _ from 'lodash'
  export default {
    props: ['value', 'track'],
    data() {
      return {
        isOpen: false,
        notesTrack: blanks.progressTrack,
      };
    },

    computed: {
      ranks() {
        return _.map(danger.dangerLevels, (value) => value)
      }
    },

    watch: {
      value(val) {
        if (val) {
          this.notesTrack = _.cloneDeep(this.track);
        } else {
          this.reset();
        }
      },
    },

    methods: {
      close() {
        this.reset();
        this.$emit('input', false);
      },
      reset() {
        this.notesTrack = blanks.progressTrack
      },
      updateTrack() {
        // Need to handle embedding the rank object properly.
        // This should switch to a lookup table and rankID
        var updatedTrack = this.notesTrack

        this.$store.dispatch('progress/updateProgressTrack', updatedTrack)
        this.close()
      }

    },
  };
</script>
